import { useEffect, useRef, useState } from 'react'

export function useHasScrollbar() {
	const ref = useRef<HTMLTableSectionElement>(null)
	const [hasScrollbar, setHasScrollbar] = useState(false)

	useEffect(() => {
		if (!ref.current) {
			return
		}

		const wrapper = ref.current

		function handleResize() {
			const scrollbarWidth = wrapper.offsetWidth - wrapper.clientWidth
			const nextValue = Boolean(scrollbarWidth)

			setHasScrollbar(nextValue)
		}

		handleResize()

		window.addEventListener('resize', handleResize)

		return () => {
			window.removeEventListener('resize', handleResize)
		}
	}, [])

	return {
		hasScrollbar,
		ref
	}
}
